import { render, staticRenderFns } from "./indexList.vue?vue&type=template&id=627b45e2"
import script from "./indexList.vue?vue&type=script&lang=js"
export * from "./indexList.vue?vue&type=script&lang=js"
import style0 from "./indexList.vue?vue&type=style&index=0&id=627b45e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports